import {
  extendObservable,
  observable,
  action,
  reaction,
  autorun,
  computed,
} from 'mobx';
import SingleRequestStore from './SingleRequestStore';
import Request from './Request';
// import RequestHandler from './RequestHandler';
// import config from './Debug/testConfig';

/**
 * @class RequestStore
 * WICHTIG: Testklasse zum Testen der Zugriff auf Stores für Requests
 * Wandert nachher hoffentlih noch in ein Requestmodul. Hoffentlich.
 * Hier erstmla nur für TestZwecje zum einbindne In DropDowns und ähnliches
 * Für jeden Request (mit einem Key) wird ein einzelner Store erstellt (s.o.)
 * Über diesen werden dann ggf. Anzeigen angepasst
 * FALLS dieser RequestStore in der Form innerhalb dieses Widgets erzeugt würde, sollte er von dem Requesthandler erzeugt werden, um ggf Abhängigkeiten innerhalb der Abfragen zu handlen
 * Was ist z.b. wenn ein DropDown eine Abfrage von was anderem beeinflusst? Ohjeh..
 */
class RequestStore {
  constructor() {
    Request.initIndexedDB();
    this.requests = {};
    extendObservable(
      this,
      {
        get useCheckedOut() {
          return false;
        },
        requests: this.requests,
        addRequest: this.addRequest,
        addRequests: this.addRequests,
        parameterStore: undefined,
        setParameterStore: this.setParameterStore,
      },
      {
        useCheckedOut: computed,
        requests: observable,
        addRequest: action,
        addRequests: action,
        parameterStore: observable,
        setParameterStore: action,
      },
    );
  }

  setParameterStore(store) {
    this.parameterStore = store;
  }

  addRequests(requestKeys) {
    this.requests = {};
    requestKeys.forEach((element) => {
      this.addRequest(element);
    });
  }

  addRequest(key, config) {
    // Nur von dem Requesthandler zu benutzen!!
    if (typeof this.requests[key] === typeof undefined) {
      this.requests[key] = new SingleRequestStore(config);
    }
    // if(typeof this.requests[element.key?element.key:element] == typeof undefined){
    //     this.requests[element.key?element.key:element] = new SingleRequestStore(element.defaultVal)
    // }
  }
}
export default new RequestStore();
